import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests/getResponseObject'
import { type AuditLogRecordApiModel } from '../api-models/AuditLogRecordApiModel'
import { AuditLogRecordApiModelStub } from '../api-models/stubs/AuditLogRecordApiModel.stub'

// Module-wide (objectless) audit log — GET /api/v3/audit/{contentTypeId}/.
// msw path segments don't span slashes, so the objectless URL needs its own
// handler (one fewer segment than mockGetAuditLog's).
export const mockGetModuleAuditLogSuccess = (
  contentTypeId: number,
  data: AuditLogRecordApiModel[] = AuditLogRecordApiModelStub.buildList(1),
  pagination = {},
  metadata = {}
) => {
  return http.get(`/api/v3/audit/${contentTypeId}/`, () => {
    return HttpResponse.json(getResponseObject(data, pagination, metadata), {
      status: 200,
    })
  })
}
